import React from "react";
import ReactDOM from "react-dom"
import Home from "./Home.jsx";
import './components/ui/universe/style';
import 'tdesign-react/es/style/index.css'; // 少量公共样式
import "./index.css";
import { MathJaxContext } from 'better-react-mathjax';

// 版本信息 (由 webpack DefinePlugin 注入)
console.log(`%c OCR Demo ${process.env.APP_VERSION} %c Build: ${process.env.BUILD_TIME} `, 
  'background: #1890ff; color: #fff; padding: 2px 6px; border-radius: 3px 0 0 3px;',
  'background: #52c41a; color: #fff; padding: 2px 6px; border-radius: 0 3px 3px 0;'
);

// 全局捕获 MathJax 相关的未处理错误，避免控制台报错
window.addEventListener('error', (event) => {
  if (event.message?.includes('Typesetting failed') ||
      event.message?.includes('nextSibling') ||
      event.message?.includes('contains')) {
    console.warn('[MathJax] Suppressed typesetting error:', event.message);
    event.preventDefault();
    return true;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('Typesetting failed') ||
      event.reason?.message?.includes('nextSibling') ||
      event.reason?.message?.includes('contains')) {
    console.warn('[MathJax] Suppressed typesetting rejection:', event.reason?.message);
    event.preventDefault();
    return true;
  }
});

// 全局 MathJax 配置
const mathJaxConfig = {
  loader: { 
    load: [
      "[tex]/html",
      "[tex]/mhchem",     // 化学公式支持 \ce{}
      "[tex]/extpfeil",   // 长等号/箭头支持 \xlongequal{}, \xrightarrow{}
      "[tex]/ams",        // AMS 数学扩展，支持 \stackrel{} 等
      "[tex]/cases"       // cases 环境支持
    ] 
  },
  tex: {
    packages: { "[+]": ["html", "mhchem", "extpfeil", "ams", "cases"] },
    inlineMath: [
      ["$", "$"],
      ["\\(", "\\)"]
    ],
    displayMath: [
      ["$$", "$$"],
      ["\\[", "\\]"]
    ]
  },
  startup: {
    typeset: false // 禁用自动 typeset，让 React 组件控制
  }
};

import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';
export default function App() {
  return (
    <MathJaxContext version={3} config={mathJaxConfig}>
      <Router>
        {/* <Route path="/" component={Home} /> */}
        <Route path="*" component={Home} />
      </Router>
    </MathJaxContext>
  )
}

const root = document.getElementById("root")
ReactDOM.render(<App />, root)

